import { getUserID } from "../Utility/service";
import { BEANSTALK_API_STORE_CREDS, BEANSTALK_API_DELETE_CREDS, BEANSTALK_API_GET_CREDS} from "../constants/Api_constants";
import { axiosSecureInstance } from "./axios";

const userId = getUserID();

export const storeBeanstalkCredsToDB = async (credential, service_id)=>{
    const body = {
        service_id : service_id,
        userId : userId,
        credentials : credential
    }
    const responseOfBeanstalkCredsStore = await axiosSecureInstance.post(BEANSTALK_API_STORE_CREDS,body);
    return responseOfBeanstalkCredsStore;
};

export const deleteBeanstalkCredsFromDB = async (service_id)=>{
    const body = {
        service_id : service_id,
        userId : userId
    }
    const responseOfBeanstalkCredsDelete = await axiosSecureInstance.post(BEANSTALK_API_DELETE_CREDS,body);
    return responseOfBeanstalkCredsDelete;
};

export const getBeanstalkCredentials = async (userId,setIsBeanstalkConnected)=>{
    const body = {
        userId : userId,
    }
    
    const responseOfBeanstalkCreds = await axiosSecureInstance.post(BEANSTALK_API_GET_CREDS,body);
   
    if(responseOfBeanstalkCreds.data.success){
        setIsBeanstalkConnected(true);
    }else{
        setIsBeanstalkConnected(false);
    }
}

export const getConnectionStatus = async(service_id) => {
    const body = {
        userId : userId,
        service_id : service_id
    }
    const status = await axiosSecureInstance.post(BEANSTALK_API_GET_CREDS,body);
    
    if(status.data.success){
        return true
    }else{
        return false;
    }
}